import { LoadingState } from './types';

const LOADING_INITIAL_STATE: LoadingState = {
  modules: []
};

export { LOADING_INITIAL_STATE };
